module.exports = __webpack_public_path__ + "dist/img/vehicle-of-interest-modal-logo.97214445.png";